import { Action } from '@ngrx/store';
import { initialDocumentLibraryState, IDocumentLibraryState } from '../../state/document-library.state';
import * as DocumentLibraryActions from '../actions/document-library.actions';
import { documentLibraryAdapter } from '../selectors/document-library.selectors';


export const documentLibraryFeatureKey = 'documentLibrary';


export function DocumentLibraryReducer(state = initialDocumentLibraryState, action: DocumentLibraryActions.DocumentLibraryActions): IDocumentLibraryState {
  switch (action.type) {
    case DocumentLibraryActions.DocumentLibraryActionTypes.RESET_DOCUMENTS:
      documentLibraryAdapter.removeAll(state);
      return {
        ...initialDocumentLibraryState
      };

    case DocumentLibraryActions.DocumentLibraryActionTypes.GET_DOCUMENTS:
      return {
        ...state,
        loading: true
      };
    case DocumentLibraryActions.DocumentLibraryActionTypes.GET_DOCUMENTS_SUCCESS:
      const getDocumentsSuccessState = {
        ...state,
        clientEntityIds: action.payload.clientEntityIds,
        loading: false
      };
      if (action.payload.documentsList) {
        return documentLibraryAdapter.upsertMany(action.payload.documentsList, getDocumentsSuccessState);
      } else {
        return {
          ...getDocumentsSuccessState
        };
      }
    case DocumentLibraryActions.DocumentLibraryActionTypes.GET_DOCUMENTS_ERROR:
    case DocumentLibraryActions.DocumentLibraryActionTypes.DOWNLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
